import { Component,  EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AddNetworkAdditionComponent } from 'src/app/network-addition/add-network-addition/add-network-addition.component';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-sms-pdp-service-live-dashboard',
  templateUrl: './sms-pdp-service-live-dashboard.component.html',
  styleUrls: ['./sms-pdp-service-live-dashboard.component.scss']
})
export class SmsPdpServiceLiveDashboardComponent implements OnInit {
  smspdpServiceLiveFormGroup: FormGroup;
  countryData: any; 
  showTable: boolean;
  nodeValue:any;
  tableData:any
hpmnCountry: any;
  nodedata: any;
  romeOrgId: any;
  constructor(private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

    ngOnInit(): void {
      this.createSmsPdpServiceLiveForm();
      this.getApiDataLoad();
      this.hpmnCountry = 'South Africa'
      
    }
    createSmsPdpServiceLiveForm() {
      this.smspdpServiceLiveFormGroup = this.formBuilder.group({
        hpmnCountry: ['South Africa'],
        vistingCountry : [''],
        nodetype: [''],
      
      });
    }
    
    async getApiDataLoad() {
      this.spinnerService.show();
      const apiUrl = this.endpointsService. URL_GET_SMSPDP_SERVICE_LIVE_DATA  ; 
      this.backendApiService.callToApi(apiUrl).subscribe(response => {
        this.countryData = response;
      });
    }
    getNodeType() {
      this.spinnerService.show();
      const visitingCountry = this.smspdpServiceLiveFormGroup.get('vistingCountry').value;
      
      // Find the selected country data from countryData array
      const selectedCountry = this.countryData.find(item => item.vistingCountry === visitingCountry);
      
      if (selectedCountry) {
        this.nodeValue = selectedCountry.type;
        this.nodedata = selectedCountry.orgId;
        this.romeOrgId = selectedCountry.roamOrgId;
        console.log("node value", this.nodedata);
        console.log("roamOrgId", this.romeOrgId);
      }
      
      this.spinnerService.hide();
    }

    onSearch() {
      this.spinnerService.show();
      const country = this.smspdpServiceLiveFormGroup.get('hpmnCountry').value;
      const visitingCountry = this.smspdpServiceLiveFormGroup.get('vistingCountry').value;
    
      console.log("Selected country:", country);
      console.log("Visiting country:", visitingCountry);
    
      let apiUrl = this.endpointsService.URL_GET_SMSPDP_SERVICE_LIVE_DATA;
    
      // If country is selected, include orgId (and roamOrgId only if visitingCountry is selected)
      if (country !== null && country !== '' && country !== undefined) {
        apiUrl += `&orgId=${this.nodedata || ''}`;
    
        // Only append roamOrgId if visitingCountry is selected (getNodeType was called)
        if (visitingCountry && visitingCountry !== '' && this.romeOrgId) {
          apiUrl += `&roamOrgId=${this.romeOrgId}`;
        }
      }
    
      console.log('Final API URL:', apiUrl);
    
      this.backendApiService.callToApi(apiUrl).subscribe(response => {
        if (response === null) {
          this.spinnerService.hide();
          return;
        }
        
        this.tableData = response;
        console.log("Table Data:", this.tableData);
        this.showTable = true;
        this.spinnerService.hide();
      });
    }
    
  //   onSearch(){
  //     this.spinnerService.show()
  //   let country = this.smspdpServiceLiveFormGroup.get('hpmnCountry').value
    
  //   // this.showTable=true;
  //   console.log("aaza",this.smspdpServiceLiveFormGroup.get('hpmnCountry').value)
  //   let apiUrl;
  //   if(country === null || country === '' || country === undefined){
  //    apiUrl = this.endpointsService.URL_GET_SMSPDP_SERVICE_LIVE_DATA;
  //   }else{
  //     apiUrl = this.endpointsService.URL_GET_SMSPDP_SERVICE_LIVE_DATA + '&orgId='+ this.nodedata + '&roamOrgId=' + this.romeOrgId;
  //   }

  // console.log('apiUrl: ' + apiUrl);
  // this.backendApiService.callToApi(apiUrl).subscribe(response => {
  //   // this.spinnerService.hide();
  //   if (response === null ) {
  //     return;
  //   }
    
  //   this.tableData = response;
  //   console.log("this.table",this.tableData)
  //   this.showTable = true;
  //   this.spinnerService.hide()
  // })
  //   }
    onReset(){
      this.spinnerService.show();
      this.showTable = false;
      this.createSmsPdpServiceLiveForm();
    }
    addService(){
      this.router.navigate(['service-live-dashboard/add-sms-pdp-live-service'])
    }

  //   addService(){
  //    const dialogRef = this.dialog.open(AddNetworkAdditionComponent, {
  //         width: '900px',
  //         panelClass: 'custom-modalbox',
  //         disableClose: true
  //       });
    
  //       dialogRef.afterClosed().subscribe(result => {
  //         if (result === "Created") {
  //           this.onSearch();
  //         }
  //       });
  // }

}
